import { memo } from "react";

export const InfoBar = memo(function InfoBar({
    scratchesLeft,
  
    controlColor,
    onControlColor,
  }: {
    scratchesLeft: number;
  
    controlColor: string;
    onControlColor: string;
  }) {
    const scratchesLeftSquareSize = "7cqw";
  
    return (
      <div
        style={{
          position: "relative",
  
          height: "17cqw",
  
          background: controlColor,
          color: onControlColor,
          overflow: "hidden",
  
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
  
          fontSize: "5cqw",
        }}
      >
        <div>
          <span
            style={{
              display: "inline-block",
              backgroundColor: onControlColor,
              color: controlColor,
              textAlign: "center",
              alignContent: "center",
              minWidth: scratchesLeftSquareSize,
              height: scratchesLeftSquareSize,
              borderRadius: `calc(${scratchesLeftSquareSize} * 0.15)`,
              marginRight: "0.5em",
              padding:
                scratchesLeft.toString().length > 1
                  ? `0 calc(${scratchesLeftSquareSize} * 0.15)`
                  : undefined,
            }}
          >
            {scratchesLeft}
          </span>
          <span>scratches left</span>
        </div>
        <div>Find 6+ treasures</div>
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "30%",
            bottom: "30%",
            transform: "translateX(-50%)",
            width: "min(0.3cqw, 4px)",
            background: "white",
          }}
        />
      </div>
    );
  });